import { QueryKey } from '@tanstack/react-query';

const baseKey: QueryKey = ['xeroInvoice'];

export const xeroInvoiceQueryKeys = {
  baseKey,
  connect: [...baseKey, 'connect'],
  status: [...baseKey, 'status'],
};
